export default __webpack_public_path__ + "assets/404.091525ce.svg";